/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserEngagementList = {
    properties: {
        totalAvailable: {
            type: 'number',
            isRequired: true,
        },
        totalProvided: {
            type: 'number',
            isRequired: true,
        },
        details: {
            type: 'array',
            contains: {
                type: 'UserEngagement',
            },
            isRequired: true,
        },
    },
} as const;
